import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { SettingsProfile } from "@/types";

export function useSettingsProfiles(): UseQueryResult<SettingsProfile[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("settingsProfiles"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<SettingsProfile[]>("/settings-profiles");
    },
    enabled: !!session,
  });
}

export function useSettingsProfile(id: string | undefined): UseQueryResult<SettingsProfile> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: id ? queryKeys.detail("settingsProfiles", id) : ["resources", "settingsProfiles", "_invalid"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<SettingsProfile>(`/settings-profiles/${id}`);
    },
    enabled: !!id && !!session,
  });
}
